import {
  EdgelessTemplatePanel,
  type TemplateManager,
} from '@blocksuite/affine/gfx/template';

// The generated edgeless/sticker template data (~490KB of inlined JSON) must not load at
// module init. The TemplateManager contract is already async (the template panel awaits
// list()/categories()/search()), so register a thin manager that dynamically imports the
// generated module on first use and delegates to it.
function lazyTemplateManager(
  load: () => Promise<{ builtInTemplates: unknown }>
): TemplateManager {
  const manager = async () =>
    (await load()).builtInTemplates as TemplateManager;
  return {
    list: async category => (await manager()).list(category),
    categories: async () => (await manager()).categories(),
    search: async (keyword, category) =>
      (await manager()).search(keyword, category),
  };
}

export function registerTemplates() {
  EdgelessTemplatePanel.templates.extend(
    lazyTemplateManager(() => import('@affine/templates/stickers'))
  );
  EdgelessTemplatePanel.templates.extend(
    lazyTemplateManager(() => import('@affine/templates/edgeless'))
  );
}
